import css, { SerializedStyles } from "@emotion/css";

export function onlyIE(rules: SerializedStyles) {
  return css`
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      ${rules};
    }
  `;
}
